export const cardOptionsData = ["armenian", "russian", "american", "paypal"];
